export class PaymentMethod {
    paymentMethodId: string
    companyId: string
    installments: number
    installmentsFee: PaymentMethodFee[]
    feePercentage: number
    comissionFeeDebt: boolean
    comissionFeeDebtAttendant: boolean
    label: string
    status: number
    createdAt: Date
    updatedAt: Date
    billIntegration: boolean
    feeFixed: number
    receiptType: 'installment' | 'full'
    receiptInterval: number
    receiptDelay: number
    firstDueInDays: number
    type: PaymentMethodTypeEnum
}

export class PaymentMethodFee {
    installment: number
    fee: number
}

export enum PaymentMethodTypeEnum {
    money = 'money',
    check = 'check',
    bankslip = 'bankslip',
    credit = 'credit',
    debit = 'debit',
    recurring = 'recurring',
    pix = 'pix',
    other = 'other',
}

export enum PaymentMethodTypeFriendlyEnum {
    money = 'Dinheiro',
    check = 'Cheque',
    bankslip = 'Boleto',
    credit = 'Crédito',
    debit = 'Débito',
    recurring = 'Recorrente',
    pix = 'Pix',
    other = 'Outro',
}
